import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { TaxClass } from "~/modules/humanResources/api/taxClass/taxClassTypes.ts";

export function indexTaxClasses(): AxiosApiResponsePromise<TaxClass[]> {
	return axiosApi.get("/tax-classes");
}